import React from 'react';

import './AboutUs.css';
import { D, rungu, dots, travel_logo } from '../../constants/images';

export const AboutUs = () => (
  <div className="app__aboutus app__bg flex__center section__padding" id="about">
    <div className="app__aboutus-overlay flex__center">
      <img src={D} alt="G_overlay" />
    </div>

    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">About Us</h1>
        <img src={dots} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">Das Grobe Abenteuer Tours and Travel (DGA Tours and Travel) is a leading tours and travel company based in Kenya. We plan, organize, and carry out tours and travel services, from tour guiding, airport pick ups and drop offs, day tours and one-day adventures, and many more.</p>
        <button type="button" className="custom__button">Know More</button>
      </div>

      <div className="app__aboutus-content_knife flex__center">
        <img src={travel_logo} alt="about_knife" />
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Our History</h1>
        <img src={dots} alt="about_spoon" className="spoon__img" />
        <p className="p__opensans">DGA Tours and Travel has been in operation since 2022, scaling the ranks of tourism and hospitality industry and becoming one of the best tours and travel providers based in Naivasha.</p>
        <button type="button" className="custom__button">Know More</button>
      </div>
    </div>
  </div>
);

// export default AboutUs;
